import Vue from 'vue'
import VueRouter from 'vue-router'
import SubjectView from '../views/subject/SubjectView'
import * as api from '@/api/Log'
import SubjectNameUtil from "@/assets/js/SubjectNameUtil";

Vue.use(VueRouter)

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			redirect: '/main',
			meta: {
				visible: false
			}
		},
		{
			path: '/main',
			name: '메인화면',
			// component: () => import('../views/Main'),
			component: () => import('../views/Main_new'),
			meta: {
				visible: false
			}
		},
		{
			path: '/kosis',
			name: 'Kosis',
			// component: () => import('../views/Main'),
			component: () => import('../views/subject/kosis'),
			meta: {
				visible: false
			}
		},
		{
			path: '/html_main', // 메인페이지 HTML 퍼블리싱
			name: 'main',
			component: () => import('../views/html/Main'),
			meta: {
				visible: false
			}
		},
		{
			path: '/statsManual', // 통계표 이용 매뉴얼 HTML 퍼블리싱
			name: 'statsManual',
			component: () => import('../views/html/StatsManual'),
			meta: {
				visible: false,
				title: '통계표 이용 매뉴얼 | 문화셈터',
			}
		},
		{
			path: '/html', // 통계표 HTML 페이지
			name: '통계표',
			component: () => import('../components/Contents'),
			meta: {
				visible: false
			},
			children: [
				{
					path: 'Stats',
					name: '문화체육관광',
					component: () =>
						import('../views/html/Stats'),
					meta: {
						visible: false,
						title: '문화 | 분야별 상세 통계 | 문화셈터',
					}
				}
			]
		},
		{
			path: '/chart/ChartPopup', // 통계표 차트 팝업 HTML 페이지
			name: 'ChartPopup',
			component: () => import('../components/popup/ChartPopup'),
			meta: {
				visible: false
			}
		},
    {
      path: '/chart/ChartFilterPopup', // 통계표 차트 팝업 HTML 페이지
      name: 'ChartFilterPopup',
      component: () => import('../components/popup/ChartFilterPopup'),
      meta: {
        visible: false
      }
    },
    {
      path: '/chart/ChartFilterIndexPopup', // 통계표 차트 팝업 HTML 페이지
      name: 'ChartFilterIndexPopup',
      component: () => import('../components/popup/ChartFilterIndexPopup.vue'),
      meta: {
        visible: false
      }
    },
		{
			path: '/error',
			name: 'error',
			component: () => import('../views/error/Error404'),
			meta: {
				visible: false
			}
		},
		{
			path: '/staticPop/:tblMgmNo/:gubun',
			name: 'staticPop',
			component: () => import('../views/subject/StaticPop'),
			props: true,
			meta: {
				visible: false
			}
		},

		// {
		// 	path: '/index', // 한눈에 보는 문화통계
		// 	name: '한눈에 보는 문화통계',
		// 	component: () => import('../components/Contents'),
		// 	meta: {
		// 		visible: false
		// 	},
		// 	children: [
		// 		{
		// 			path: 'index01/:subItemId',
		// 			name: '지표통계',
		// 			component: () =>
		// 				import('../views/index/Index01'),
		// 			props: true,
		// 			meta: {
		// 				visible: false,
		// 				title: '지표통계 | 한눈에 보는 문화통계 | 문화셈터',
		// 				subMenuItemType: 'STBL',
		// 				subMenuItemMgmNo: 'STBL-1025445'
		// 			},
		// 			children: [
		// 				{
		// 				path: 'stat/:childStatId',
		// 				name: '지표통계/서브',
		// 				props: true,
		// 				meta: {
		// 					visible: true,
		// 					subMenuItemMgmNo: 'STBL-1025445'
		// 				}
		// 				}
		// 			]
		// 		},
		// 		{
		// 			path: 'index02/',
		// 			name: 'e-나라지표',
		// 			component: () =>
		// 				import('../views/index/Index02'),
		// 			props: true,
		// 			meta: {
		// 				visible: true,
		// 				title: 'e-나라지표 | 한눈에 보는 문화통계 | 문화셈터',
		// 				//subMenuItemType: 'CODE',		2024년 문화셈터 기능개선
		// 				//subMenuItemMgmNo: '000000'
		// 			}
		// 		},
		// 		{
		// 			path: 'kctiData',
		// 			name: 'KCTI Data(정책지표)',
		// 			/* component: () =>
		// 				import('../views/index/KctiData'),
		// 			props: true,
		// 			meta: {
		// 				visible: true
		// 			}*/
		// 			meta: {
		// 				visible: true,
		// 				linkUrl: process.env.VUE_APP_DATA_KCTI_SERVER
		// 			}
		// 		}
		// 	]
		// },

		{
			path: '/subject', // 주제별통계
			name: '분야별 상세 통계',
			component: () => import('../components/Contents'),
			meta: {
				visible: true
			},
			children: [
				{
					path: 'subject01/:subItemId',
					name: '문화',
					component: SubjectView,
					props: true,
					meta: {
						visible: true,
						title: '문화 | 분야별 상세 통계 | 문화셈터',
						baseRouteName: '문화',
						subjectId: 'subject01',
						subMenuItemType: 'STBL',
						subMenuItemMgmNo: 'STBL-1014250'
					},
					children: [
						{
							path: 'stat/:statId',
							name: '문화 > 통계표',
							props: true,
							meta: {
								baseRouteName: '문화',
								subjectId: 'subject01',
								subMenuItemMgmNo: 'STBL-1014250'
							}
						},
						{
							path: 'report',
							name: '문화 > 통계보고서',
							props: true,
							meta: {
								baseRouteName: '문화',
								subjectId: 'subject01',
								subMenuItemMgmNo: 'STBL-1014250'
							}
						},
						{
							path: 'mdss',
							name: '문화 > MDSS',
							props: true,
							meta: {
								baseRouteName: '문화',
								subjectId: 'subject01',
								subMenuItemMgmNo: 'STBL-1014250'
							}
						},
						{
							path: 'meta',
							name: '문화 > 메타정보',
							props: true,
							meta: {
								baseRouteName: '문화',
								subjectId: 'subject01',
								subMenuItemMgmNo: 'STBL-1014250'
							}
						},
					]
				},
				{
					path: 'subject02/:subItemId',
					name: '예술',
					component: SubjectView,
					props: true,
					meta: {
						visible: true,
						title: '예술 | 분야별 상세 통계 | 문화셈터',
						baseRouteName: '예술',
						subjectId: 'subject02',
						subMenuItemType: 'STBL',
						subMenuItemMgmNo: 'STBL-1030638'
					},
					children: [
						{
							path: 'stat/:statId',
							name: '예술 > 통계표',
							props: true,
							meta: {
								baseRouteName: '예술',
								subjectId: 'subject02',
								subMenuItemMgmNo: 'STBL-1030638'
							}
						},
						{
							path: 'report',
							name: '예술 > 통계보고서',
							props: true,
							meta: {
								baseRouteName: '예술',
								subjectId: 'subject02',
								subMenuItemMgmNo: 'STBL-1030638'
							}
						},
						{
							path: 'mdss',
							name: '예술 > MDSS',
							props: true,
							meta: {
								baseRouteName: '예술',
								subjectId: 'subject02',
								subMenuItemMgmNo: 'STBL-1030638'
							}
						},
						{
							path: 'meta',
							name: '예술 > 메타정보',
							props: true,
							meta: {
								baseRouteName: '예술',
								subjectId: 'subject02',
								subMenuItemMgmNo: 'STBL-1030638'
							}
						},
					]
				},
				{
					path: 'subject03/:subItemId',
					name: '콘텐츠',
					component: SubjectView,
					props: true,
					meta: {
						visible: true,
						title: '콘텐츠 | 분야별 상세 통계 | 문화셈터',
						baseRouteName: '콘텐츠',
						subjectId: 'subject03',
						subMenuItemType: 'STBL',
						subMenuItemMgmNo: 'STBL-1014252'
					},
					children: [
						{
							path: 'stat/:statId',
							name: '콘텐츠 > 통계표',
							props: true,
							meta: {
								baseRouteName: '콘텐츠',
								subjectId: 'subject03',
								subMenuItemMgmNo: 'STBL-1014252'
							}
						},
						{
							path: 'report',
							name: '콘텐츠 > 통계보고서',
							props: true,
							meta: {
								baseRouteName: '콘텐츠',
								subjectId: 'subject03',
								subMenuItemMgmNo: 'STBL-1014252'
							}
						},
						{
							path: 'mdss',
							name: '콘텐츠 > MDSS',
							props: true,
							meta: {
								baseRouteName: '콘텐츠',
								subjectId: 'subject03',
								subMenuItemMgmNo: 'STBL-1014252'
							}
						},
						{
							path: 'meta',
							name: '콘텐츠 > 메타정보',
							props: true,
							meta: {
								baseRouteName: '콘텐츠',
								subjectId: 'subject03',
								subMenuItemMgmNo: 'STBL-1014252'
							}
						},
					]
				},
				{
					path: 'subject04/:subItemId',
					name: '관광',
					component: SubjectView,
					props: true,
					meta: {
						visible: true,
						title: '관광 | 분야별 상세 통계 | 문화셈터',
						baseRouteName: '관광',
						subjectId: 'subject04',
						subMenuItemType: 'STBL',
						subMenuItemMgmNo: 'STBL-1014253'
					},
					children: [
						{
							path: 'stat/:statId',
							name: '관광 > 통계표',
							props: true,
							meta: {
								baseRouteName: '관광',
								subjectId: 'subject04',
								subMenuItemMgmNo: 'STBL-1014253'
							}
						},
						{
							path: 'report',
							name: '관광 > 통계보고서',
							props: true,
							meta: {
								baseRouteName: '관광',
								subjectId: 'subject04',
								subMenuItemMgmNo: 'STBL-1014253'
							}
						},
						{
							path: 'mdss',
							name: '관광 > MDSS',
							props: true,
							meta: {
								baseRouteName: '관광',
								subjectId: 'subject04',
								subMenuItemMgmNo: 'STBL-1014253'
							}
						},
						{
							path: 'meta',
							name: '관광 > 메타정보',
							props: true,
							meta: {
								baseRouteName: '관광',
								subjectId: 'subject04',
								subMenuItemMgmNo: 'STBL-1014253'
							}
						},
					]
				},
				{
					path: 'subject05/:subItemId',
					name: '체육',
					component: SubjectView,
					props: true,
					meta: {
						visible: true,
						title: '체육 | 분야별 상세 통계 | 문화셈터',
						baseRouteName: '체육',
						subjectId: 'subject05',
						subMenuItemType: 'STBL',
						subMenuItemMgmNo: 'STBL-1014255'
					},
					children: [
						{
							path: 'stat/:statId',
							name: '체육 > 통계표',
							props: true,
							meta: {
								baseRouteName: '체육',
								subjectId: 'subject05',
								subMenuItemMgmNo: 'STBL-1014255'
							}
						},
						{
							path: 'report',
							name: '체육 > 통계보고서',
							props: true,
							meta: {
								baseRouteName: '체육',
								subjectId: 'subject05',
								subMenuItemMgmNo: 'STBL-1014255'
							}
						},
						{
							path: 'mdss',
							name: '체육 > MDSS',
							props: true,
							meta: {
								baseRouteName: '체육',
								subjectId: 'subject05',
								subMenuItemMgmNo: 'STBL-1014255'
							}
						},
						{
							path: 'meta',
							name: '체육 > 메타정보',
							props: true,
							meta: {
								baseRouteName: '체육',
								subjectId: 'subject05',
								subMenuItemMgmNo: 'STBL-1014255'
							}
						},
					]
				},
				{
					path: 'subject06/:subItemId',
					name: '종합',
					component: SubjectView,
					props: true,
					meta: {
						visible: true,
						title: '종합 | 분야별 상세 통계 | 문화셈터',
						baseRouteName: '종합',
						subjectId: 'subject06',
						subMenuItemType: 'STBL',
						subMenuItemMgmNo: 'STBL-1030639'
					},
					children: [
						{
							path: 'stat/:statId',
							name: '종합 > 통계표',
							props: true,
							meta: {
								baseRouteName: '종합',
								subjectId: 'subject06',
								subMenuItemMgmNo: 'STBL-1030639'
							}
						},
						{
							path: 'report',
							name: '종합 > 통계보고서',
							props: true,
							meta: {
								baseRouteName: '종합',
								subjectId: 'subject06',
								subMenuItemMgmNo: 'STBL-1030639'
							}
						},
						{
							path: 'mdss',
							name: '종합 > MDSS',
							props: true,
							meta: {
								baseRouteName: '종합',
								subjectId: 'subject06',
								subMenuItemMgmNo: 'STBL-1030639'
							}
						},
						{
							path: 'meta',
							name: '종합 > 메타정보',
							props: true,
							meta: {
								baseRouteName: '종합',
								subjectId: 'subject06',
								subMenuItemMgmNo: 'STBL-1030639'
							}
						},
					]
				},
				{
					path: 'multiStbl',
					name: '복합통계',
					component: () =>
						import('../views/subject/MultiStbl'),
					props: true,
					meta: {
						visible: false,
						title: '복합통계 | 분야별 상세 통계 | 문화셈터',
					}
				},
        {
          path: 'subject07/',
          name: 'e-나라지표',
          component: () =>
            import('../views/index/Index02'),
          props: true,
          meta: {
            visible: true,
            title: 'e-나라지표 | 분야별 상세 통계 | 문화셈터',
            //subMenuItemType: 'CODE',		2024년 문화셈터 기능개선
            //subMenuItemMgmNo: '000000'
          }
        },
			]
		},
		{
			path: '/visual', // 시각화
			name: '시각화',
			component: () => import('../components/Contents'),
			meta: {
				visible: false
			},
			children: [
				{
					path: 'sns',
					name: 'SNS분석',
					component: () =>
						import('../views/visual/Sns'),
					meta: {
						visible: true,
						title: 'SNS분석 | 시각화 | 문화셈터',
					}
				},
				{
					path: 'snsWordCloud',
					name: 'SNS워드클라우드',
					component: () =>
						import('../views/visual/snsWordCloud'),
					meta: {
						visible: false,
						title: 'SNS분석 | 시각화 | 문화셈터',
					}
				},
				{
					path: 'map',
					name: '지도통계',
					meta: {
						visible: true,
						linkUrl: process.env.VUE_APP_MAP_SERVER
					}
				},
				{
					path: 'statCharts',
					name: '주요통계지표',
					component: () =>
						import('../views/visual/StatCharts'),
					meta: {
						visible: true,
						title: '주요통계지표 | 시각화 | 문화셈터',
					}
				}
			]
		},
		{
			path: '/info', // 정보공유
			name: '통계 자료실',
			component: () => import('../components/Contents'),
			meta: {
				visible: true
			},
			children: [
				{
					path: 'statReport',
					name: '통계 보고서',
					component: () =>
						import('../views/info/StatReport_new'),
					meta: {
						visible: true,
						title: '통계보고서 | 통계 자료실 | 문화셈터',
					}
				},
				{
					path: 'statReport/detail/:anlDetailNo(\\d+)',
					component: () => import('../views/info/StatReportDetail'),
					name: '통계 보고서 상세',
					hidden: true,
					props : true,
					meta: { title: '통계보고서 상세 | 통계 자료실 | 문화셈터' }
				},
				{
					path: 'indexReport',
					name: '지표 보고서',
					props: true,
					component: () =>
						import('../views/info/IndexReport'),
					meta: {
						visible: false,
						title: '지표보고서 | 통계 자료실 | 문화셈터',
					}
				},
				{
					path: 'indexReport/indexReportDetail',
					name: '지표보고서 상세',
					component: () => import('../components/BoardDetailItem'),
					props: true,
					meta: {
						visible: false,
						title: '지표보고서 상세 | 통계 자료실 | 문화셈터',
					}
				},
				{
					path: 'etcData',
					name: '기타 자료실',
					component: () =>
						import('../views/info/EtcData'),
					meta: {
						visible: true,
						title: '기타자료실 | 통계 자료실 | 문화셈터',
					}
				},
				{
					path: 'infographic',
					name: '인포그래픽',
					component: () =>
						import('../views/visual/Infographic'),
					meta: {
						visible: false,
						title: '인포그래픽 | 시각화 | 문화셈터',
					}
				},
				{
					path: 'specialCategory', //2024년 문화셈터 기능개선 이전
					name: '특수분류_old',
					component: () =>
						import('../views/info/SpecialCategory'),
					meta: {
						visible: false,
						title: '특수분류 | 통계 자료실 | 문화셈터',
					}
				},
				{
					path: 'spclClsf',
					name: '특수분류_old2',
					component: () =>
						import('../views/info/SpclClsf'),
					meta: {
						visible: false,
						title: '특수분류 | 통계 자료실 | 문화셈터',
						menuInfo: '문화체육관광분야 특수분류체계 정보 제공'
					}
				},
				{
					path: 'spclCtgry',
					name: '특수분류',
					component: () =>
						import('../views/info/SpclCtgry'),
					meta: {
						visible: true,
						title: '특수분류 | 통계 자료실 | 문화셈터',
						menuInfo: '문화체육관광분야 특수분류체계 정보 제공'
					}
				},
				{
					path: 'statsSite',
					name: '국내외 문화 통계 사이트',
					component: () =>
						import('../views/subject/StatsSite'),
					props: true,
					meta: {
						visible: true,
						title: '국내외 문화 통계 사이트 | 통계 자료실 | 문화셈터',
					}
				},
				{
					path: 'statsSite/statsSiteDetail',
					name: '국내외 문화 통계 사이트 상세',
					component: () => import('../components/StatsSiteDetailItem'),
					props: true,
					meta: {
						visible: false,
						title: '국내외 문화 통계 사이트 상세 | 통계 자료실 | 문화셈터',
						menuInfo: '국내외 통화 통계 사이트 상세'
					}
				},
				{
					path: 'html_statsSite', // 국내외 문화 통계 페이지 HTML 퍼블리싱
					name: '국내외 문화 통계 사이트#html',
					component: () =>
						import('../views/subject/StatsSite_html'),
					props: true,
					meta: {
						visible: false,
						title: 'Kosis Test',
					}
				},
				{
					path: 'industryCategory',
					name: '산업분류',
					component: () =>
						import('../views/info/IndustryCategory'),
					meta: {
						visible: false,
						title: '산업분류 | 통계 자료실 | 문화셈터',
					}
				},
				{
					path: 'etcData/etcDataDetail',
					name: '기타자료실 상세',
					component: () => import('../components/BoardDetailItem'),
					props: true,
					meta: {
						visible: false,
						title: '기타자료실 상세 | 통계 자료실 | 문화셈터',
					}
				}
			]
		},
		{
			path: '/notice', // 공지·알림
			name: '자료 공유',
			component: () => import('../components/Contents'),
			meta: {
				visible: true
			},
			children: [
				{
					path: 'StatsOpenApi',
					name: 'Open API',
					component: () =>
						import('../views/info/StatsOpenApi'),
					meta: {
						visible: true,
						title: '통계표 Open API | 자료 공유 | 문화셈터',
					}
				},
				{
					path: 'MdssOpenApi',
					name: 'MDSS Open API',
					component: () =>
						import('../views/info/MdssOpenApi'),
					meta: {
						visible: false,
						title: 'MDSS Open API | 자료 공유 | 문화셈터',
					}
				},
				{
					path: 'mdss',
					name: 'MDSS',
					component: () =>
						import('../views/info/Mdss'),
					props: true,
					meta: {
						visible: true,
						title: 'MDSS | 자료 공유 | 문화셈터',
					}
				},
				{
					path: 'ducInfomation',
					name: '대회 안내',
					component: () =>
						import('../views/notice/DucInfomation'),
					meta: {
						visible: false,
						title: '대회 안내 | 자료 공유 | 문화셈터',
					}
				},
				{
					path: 'ducNotice',
					name: '통계 활용대회',
					component: () =>
						import('../views/notice/DucNotice'),
					meta: {
						visible: true,
						title: '대회 공지사항 | 자료 공유 | 문화셈터',
					}
				},
				// {
				// 	path: 'culture',
				// 	name: '문화 공공데이터 광장',
				// 	meta: {
				// 		visible: false,
				// 		linkUrl: process.env.VUE_APP_CULTURE_SERVER
				// 	}
				// },
			]
		},
		{
			path: '/intro', // 소개마당
			name: '소개 및 안내',
			component: () => import('../components/Contents'),
			meta: {
				visible: true
			},
			children: [
				{
					path: 'mcstOperationIntro',
					name: '문화체육관광 통계개발 운영사업 소개',
					component: () =>
						import('../views/intro/McstOperationIntro'),
					meta: {
						visible: false,
						title: '문화체육관광 통계개발 운영사업 소개 | 소개 및 안내 | 문화셈터',
					}
				},
				{
					path: 'McstStatInfo',
					name: '문화셈터 소개',
					component: () =>
						import('../views/intro/McstStatIntro.vue'),
					meta: {
						visible: true,
						title: '문화셈터 소개 | 소개 및 안내 | 문화셈터',
					}
				},
        {
          path: 'mcstScheduleInfo',
          name: '통계공표 일정',
          component: () =>
            import('../views/intro/McstScheduleInfo'),
          meta: {
            visible: true,
            title: '통계공표 일정 | 소개 및 안내 | 문화셈터',
          }
        },
        {
          path: 'faq',
          name: '이용안내',
          component: () =>
            import('../views/notice/Faq'),
          meta: {
            visible: true,
            title: '이용안내 | 소개 및 안내 | 문화셈터',
          }
        },
        {
          path: 'faq/faqDetail',
          name: '이용안내 상세',
          component: () => import('../components/BoardDetailItem'),
          props: true,
          meta: {
            visible: false,
            title: '이용안내 상세 | 소개 및 안내 | 문화셈터',
          }
        },
				{
					path: 'notice',
					name: '공지사항',
					component: () =>
						import('../views/notice/Notice'),
					meta: {
						visible: true,
						title: '공지사항 | 소개 및 안내 | 문화셈터',
					}
				},
				{
					path: 'notice/noticeDetail',
					name: '공지사항 상세',
					component: () => import('../components/BoardDetailItem'),
					props: true,
					meta: {
						visible: false,
						title: '공지사항 상세 | 소개 및 안내 | 문화셈터',
					}
				},
				{
					path: 'copyright',
					name: '저작권정책',
					component: () =>
						import('../views/notice/Copyright'),
					meta: {
						visible: true,
						title: '저작권정책 | 소개 및 안내 | 문화셈터',
					}
				}
				// {
				//   path: "siteMap",
				//   name: "사이트맵",
				//   component: () =>
				//     import("../views/intro/SiteMap"),
				//   meta: {
				//     visible: true,
				//     menuInfo: '사이트맵'
				//   }
				// }
			]
		},
		{
			path: '/duc', // 데이터 활용대회
			name: '통계 활용대회',
			component: () => import('../components/Contents'),
			meta: {
				visible: false
			},
			children: [
				{
					path: 'ducDetail',
					name: '대회 공지사항 상세',
					component: () => import('../components/BoardDetailItem'),
					props: true,
					meta: {
						visible: false,
						title: '대회 공지사항 | 통계 활용대회 | 문화셈터',
					}
				}
			]
		},
		{
			path: '/search',
			name: '검색',
			component: () => import('../components/Contents'),
			meta: {
				visible: true,
				visibleMenu: false
			},
			children: [
				{
					path: 'search',
					name: '통합검색',
					component: () =>
						import('../views/search/Search'),
					meta: {
						visible: true,
						title: '통합검색 | 문화셈터',
					}
				},
				{
					path: 'DataMap',
					name: '데이터맵',
					component: () =>
						import('../views/search/DataMap'),
					meta: {
						visible: true,
						title: '데이터맵 | 문화셈터',
					}
				}
			]
		},
		{
			path: '/sns/single',
			name: 'single',
			component: () => import('../views/visual/SnsSingle'),
			meta: {
				visible: false
			}
		},
	],
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
      //INFO 동일한 메뉴 뎁스에서 스크롤을 고정
      if (to && from && to.meta && from.meta && to.meta.baseRouteName === from.meta.baseRouteName) {
        return {x: window.positionX, y: window.positionY};
      } else {
        return { x: 0, y: 0 };
      }
		}
	}
})

//INFO 개발모드에서는 error 페이지를 표시하지 않음
if (process.env.NODE_ENV !== 'development') {
  router.addRoute(	{
    path: '*',
    redirect: '/error',
    meta: {
      visible: false
    }
  });
}

SubjectNameUtil.initialize(router);

router.afterEach((to, from) => {
  api.access();
	const title = to.meta.title === undefined ? '문화셈터' : to.meta.title;
	Vue.nextTick(() => {
		document.title = title;
	});
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
	return originalPush.call(this, location).catch(err => {
		if (err && err.name !== 'NavigationDuplicated') throw err
	})
}
export default router
